<template>
  <v-dialog
    v-model="visible"
    max-width="400px"
    persistent
  >
    <v-card class="pa-3">
      <h2>
        ¿ Confirma la anulacion del turno ?
      </h2>
      <div>
        Profesional: {{ appointment.profesional }}
      </div>
      <div>
        Fecha: {{ fecha }}
      </div>
      <div class="text-xs-right mt-4">
        <v-btn
          class="error"
          :disabled="loading"
          :loading="loading"
          @click="cancelAppointment"
        >
          Anular
        </v-btn>
        <v-btn
          class="primary"
          :disabled="loading"
          @click="closeModal"
        >
          Cancelar
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { anularTurno } from '../../api/appointmentsEndpoints'
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'AppointmentCancelModal',
  filters: {

  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    appointment: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters(['user']),
    fecha () {
      moment.locale('es')
      const hora = this.appointment.hora
      const fecha = this.appointment.fecha
      let parsedFecha = ''
      if (fecha) {
        parsedFecha = `${fecha.substring(0, 4)}-${fecha.substring(4, 6)}-${fecha.substring(6, 8)}`
      }
      return `${moment(parsedFecha).format('dddd').toUpperCase()} ${moment(parsedFecha).format('DD-MM-YYYY')} a las ${hora}`
    }
  },
  methods: {
    async cancelAppointment () {
      const prepareObject = {
        pacienteId: this.user.id,
        turno: this.appointment.turno
      }
      this.loading = true
      const removeAppointment = await anularTurno(prepareObject)
      this.closeModal()
      this.loading = false
      if (removeAppointment.respuesta === 'ERROR') {
        this.$createAlert({
          message: removeAppointment.mensaje,
          type: 'error',
          duration: 5000
        })
      } else {
        this.$createAlert({
          message: 'Turno Anulado',
          type: 'success',
          duration: 3000
        })
      }
      await this.$emit('reloadAppointments')
      // this.$router.push('/seleccion')
    },
    closeModal () {
      this.$emit('cancel')
    }
  }
}
</script>
